import { Instant } from "@js-joda/core";
import { DashboardComponentType, DashboardComponentTypeBase } from "api/model/dashboard/DashboardComponent";
import { ComponentTypeMappings } from "components/component-mappings";
import React, { useEffect, useState } from "react";
import { T } from "services/lang/LanguageService";
import { DweenCalendarEnum } from "utils/enums";
import ErrorBoundary from "../../../ErrorBoundary";
import { DashboardComponentPropsBase, DashboardComponentState } from "./interfaces";

export const getFullComponentId = (
  type: string,
  tabIndex: number,
  groupIndex: number,
  componentIndex: number
) => {
  return `${type}-${tabIndex}-${groupIndex}-${componentIndex}`;
};

export const DashboardComponentMappingWrapper = (props: {
  id: string;
  component: DashboardComponentType;
  config: any;
  referenceTime: string;
  instantReferenceTime: Instant;
  calendarType?: DweenCalendarEnum;
  stateCb?: (state: DashboardComponentState) => void;
}) => {
  const config: any = {
    ...props.config,
    id: props.id,
    referenceTime: props.referenceTime,
    instantReferenceTime: props.instantReferenceTime,
    stateCb: props.stateCb,
    reportMode: true,
    calendarType: props.calendarType,
  } as DashboardComponentPropsBase;

  const [LoadedComponent, setLoadedComponent] = useState<React.ComponentType<any> | null>(null);

  useEffect(() => {
    const mapping = ComponentTypeMappings[props.component as DashboardComponentTypeBase];
    if (mapping && mapping.entryPoint) {
      mapping
        .entryPoint()
        .then((mod: any) => {
          setLoadedComponent(() => mod.default || mod);
        })
        .catch(() => {
          setLoadedComponent(null);
        });
    } else {
      setLoadedComponent(null);
    }
  }, [props.component]);

  const onCrash = (msg: string) => {
    if (props.stateCb) {
      props.stateCb({ id: props.id, state: "error", error: msg });
    }
  };

  return (
    <ErrorBoundary onError={onCrash}>
      {LoadedComponent ? (
        <LoadedComponent key={props.id} {...config} />
      ) : (
        <div>
          {T("error.invalid-unknown-component")}: {props.component}
        </div>
      )}
    </ErrorBoundary>
  );
};
